import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-media-index',
  templateUrl: './media-index.component.html',
  styleUrls: ['./media-index.component.scss']
})
export class MediaIndexComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
